export interface ILayoutStore {
  isSidebarOpen: boolean | null;
}

export const layoutStoreInitialState: ILayoutStore = {
  isSidebarOpen: true,
};
